/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { MidasEffectError, OverviewView } from '@midas/shared/common';
import { createAction, props } from '@ngrx/store';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { ViewsLocations } from 'libs/overview/shell/src/lib/overview-views/views-filter/locations.interface';

export const queryOverviewViews = createAction(
  '[OverviewViews] Query OverviewViews',
  props<{ limit: number; offset: number }>(),
);

export const queryOverviewViewBySearchValue = createAction(
  '[OverviewViews] Query OverviewView By Search Value',
  props<{ searchValue: string, statusIds: number[], locationIds: number[]}>(),
);

export const queryOverviewViewGetLocations = createAction(
  '[OverviewViews] Query OverviewView Get Locations',
  props<{ limit: number; offset: number }>(),
);

export const queryOverviewViewGetLocationsSuccess = createAction(
  '[OverviewViews] Query OverviewView Get Locations Success',
  props<{ locations: ViewsLocations[] }>(),
);

export const queryOverviewViewGetLocationsError = createAction(
  '[OverviewViews] Query OverviewView Get Locations Error',
  props<MidasEffectError>(),
);

export const queryOverviewViewsSuccess = createAction(
  '[OverviewViews] Query OverviewViews Success',
  props<{ carts: OverviewView[], locations: ViewsLocations[] }>(),
);
export const queryOverviewViewsError = createAction(
  '[OverviewViews] Query OverviewViews Error',
  props<MidasEffectError>(),
);

export const queryOverviewViewBySearchValueSuccess = createAction(
  '[OverviewViews] Query OverviewView By Search Value Success',
  props<{carts: OverviewView[] }>(),
);

export const queryOverviewViewBySearchValueError = createAction(
  '[OverviewViews] Query OverviewView By Search Value Error',
  props<MidasEffectError>(),
);
